import React from 'react'

import { RegularTableBodyProps } from './types'

const RegularTableBody = <T extends object>({
  value,
  rowComponent,
}: RegularTableBodyProps<T>) => {
  return (
    <>
      {value.map((instance, index) => (
        <React.Fragment key={index}>
          {rowComponent({ instance })}
        </React.Fragment>
      ))}
    </>
  )
}

export { RegularTableBody }
